/**
 * Module definition houses all application authoring
 *
 * @module components.authoring
 */
angular.module('components.authoring', [
  'components.authoring.header'
]);
